module.exports = __webpack_public_path__ + "static/StreetcarCeiling-db6ba0711185f3e216d2608eed90ff92.jpg";